export const dashboardCookieName = 'contrast_dashboard'
